import React from 'react';
import styled from 'styled-components';
import { black, gray } from 'styles/abstracts/colors';
import Loader from '_Components/Loader/OnLoad';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  // width: 100%;
  flex: auto;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${black};
  font-size: 1.2rem;
  font-weight: bold;
`;

const DescriptionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${gray};
  font-size: 0.8rem;
  font-weight: bold;
`;

type ListTitleType = {
  listTitle: string;
  listDescription: string;
  loadingThematicOverview: boolean;
};

const ListTitle = ({ listTitle, listDescription, loadingThematicOverview }: ListTitleType) => {
  return (
    <HeaderContainer>
      <TitleContainer>
        {listTitle}
        {loadingThematicOverview && <Loader />}
      </TitleContainer>
      <DescriptionContainer>{listDescription}</DescriptionContainer>
    </HeaderContainer>
  );
};

export default ListTitle;
